@if (cardData) {
    <a class="card mb-0 h-100"
       [routerLink]="organisationUrl$ | async"
       [attr.data-test]="'org-card'"
       [ngClass]="{
            'is-current-organisation': isCurrentOrganisation$ | async,
        }"
       adaptTooltip="Switch to this organisation"
       [tooltipEnabled]="(isCurrentOrganisation$ | async) === false">
        <div class="card-header pt-3">
            <adapt-storage-image [imageIdentifier]="cardData!.organisation.imageIdentifier"
                                 [imageHeight]="40"
                                 [imageWidth]="215"
                                 defaultImageSrc="/content/images/default_organisation.png"></adapt-storage-image>
        </div>
        <div class="card-body pt-2">
            <h2 class="card-title">
                @if (isCurrentOrganisation$ | async) {
                    <span class="is-current-organisation-icon fa-stack fa-2x"
                          adaptTooltip="This is the organisation you are currently viewing">
                        <i class="fas fa-circle fa-stack-2x"></i>
                        <i class="fal fa-check fa-stack-1x fa-inverse"></i>
                    </span>
                }
                {{ cardData!.organisation.name }}
            </h2>
            <div class="d-flex mt-2">
                @for (connectionType of cardData!.connectionTypes; track connectionType) {
                    <span class="connection-type-badge badge"
                          [ngClass]="connectionTypeToBadgeClass[connectionType]">
                        {{ connectionType }}
                    </span>
                }
            </div>
            @if (cardData!.isArchived) {
                <div class="mt-2 d-flex">
                    <span class="ms-auto badge bg-light text-dark text-muted"
                          adaptTooltip="This organisation is archived and read-only."> <i class="fal fa-archive pe-1"></i><i>Archived</i>
                    </span>
                </div>
            }
        </div>
    </a>
}
